import { useQuery } from '@tanstack/react-query';
import { IProfessionalCountsResponse } from '../types/IProfessionalCountsResponse';
import { ProfessionalsService } from '../services/ProfessionalsService';
import { factoryGetProfessionalCountsByLocationKey } from '../factories/queries/factoryGetProfessionalCountsByLocationKey';

const FIVE_MINUTES = 5 * 60 * 1000;

interface IUseGetProfessionalCountsByLocationOptions {
  enable?: boolean;
  distance?: number;
  authorized?: boolean;
}

export const useGetProfessionalCountsByLocation = (
  lat: number,
  lng: number,
  options: IUseGetProfessionalCountsByLocationOptions = {},
) => {
  const { enable = true, distance, authorized } = options;
  const hasCoords = Number.isFinite(lat) && Number.isFinite(lng);

  const { data, isLoading, isFetching, isError } = useQuery<IProfessionalCountsResponse>({
    queryKey: factoryGetProfessionalCountsByLocationKey({ lat, lng, distance, authorized }),
    queryFn: () =>
      ProfessionalsService.getProfessionalCountsByLocation({ lat, lng, distance, authorized }),
    enabled: enable && hasCoords,
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: FIVE_MINUTES,
  });

  const totalCount = data?.byProfession
    ? Object.values(data.byProfession).reduce((sum, n) => sum + n, 0)
    : 0;

  return {
    totalCount,
    countsByProfession: data?.byProfession,
    isLoading: isLoading || isFetching,
    isError,
  };
};
